import { getOrdersForUserId } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const fetcher = async (request: [string, string]) => {
  const [userId] = request;
  return getOrdersForUserId(userId);
};

const useOrderListForUser = (userId?: string) => {
  const {
    data,
    error,
    isValidating: orderListLoading,
  } = useSWR(userId ? [userId, 'order-list'] : null, fetcher, {
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
  });

  return {
    orderList: data?.sort((a, b) => (a.orderDate < b.orderDate ? 1 : a.orderDate === b.orderDate ? 0 : -1)),
    error,
    orderListLoading,
  };
};

export default useOrderListForUser;
